import { getUserInfo } from "../service/user";

const user = {
  name: "user",
  state: null, // initial state
  reducers: {
    // handle state changes with pure functions
    setUser(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    async setUserAsync() {
      const user = await getUserInfo();
      this.setUser(user);
      return user
    },
  }),
};

export default user
